import { CTASection } from "@/components/shared/CTASection";

export const FinalCTA = () => (
  <CTASection
    heading="Let's Find the Right Teacher for Your School"
    description="Tell us what your school is looking for and our recruitment team can help you identify suitable teaching professionals."
    primaryLabel="Find the Right Teacher"
    primaryTo="/contact-us#enquiry"
    secondaryLabel="Contact Mithra Jobs"
    secondaryTo="/contact-us"
    testIdPrefix="final-cta"
  />
);
